import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SwipeableViews from 'react-swipeable-views';
import { Tab, Tabs, withStyles } from '@material-ui/core';
import { Close, } from '@material-ui/icons';
import { receive_profile } from "../../../apis/redux/fetchActions";
import APIService from "../../../apis/amplify/APIService";
import SectionTitleContainer, { SectionTitle } from "../../../components/SectionTitleContainer";
import Notification, { ERROR_TYPE, NActionButton, SUCCESS_TYPE } from "../../../components/Notification";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import ProfileEditor from './ProfileEditor';
import PassEditor from './PassEditor';
import { ignoreFirstArg, propSwitcher } from '../../../util/functions';
import { styles } from './styles'

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showNotification: false,
            notificationText: '',
            notificationType: SUCCESS_TYPE,
            loading: false,
            loadingText: '',
            profileUpdateError: '',
            tabIndex: 0,
            savingProfile: false,
            savingPassword: false,
            passwordInvalid: false,
            profileEditable: false,
            clearPasswordForm: null,
            isCurrentPasswordInvalid: null,
            passwordChangeError: ''
        };
    }

    handleChangeIndex = index => {
        this.setState({ tabIndex: index });
    };

    profileSubmit = async ({name, surnames, phone, email}) => {
        this.setState({savingProfile: true, profileUpdateError: ''});
        const { ok, data } = await APIService.updateProfile({ name, surnames, phone, email });
        if (ok) {
            this.props.actions.receiveProfile(data);
            this.setState({
                notificationText: 'Profile successfully updated',
                showNotification: true,
                notificationType: SUCCESS_TYPE,
            });
        } else {
            this.setState({
                notificationText: ':( We detected an unexpected error.',
                showNotification: true,
                notificationType: ERROR_TYPE,
            });
        }
        this.setState({savingProfile: false, profileEditable: false});
    };

    passwordSubmit = async ({password, newPassword}) => {
        this.setState({savingPassword: true, passwordChangeError: ''});
        const { ok, status } = await APIService.updateUserPassword(password, newPassword);
        if (ok) {
            this.setState({
                notificationText: 'Password successfully updated',
                showNotification: true,
                notificationType: SUCCESS_TYPE,
                clearPasswordForm: propSwitcher(true),
            });
        } else if (status === 403) {
            this.setState({
                isCurrentPasswordInvalid: propSwitcher(true),
                passwordChangeError: 'The current password is not valid',
            });
        } else {
            this.setState({
                notificationText: ':( We detected an unexpected error',
                showNotification: true,
                notificationType: ERROR_TYPE,
            });
        }
        this.setState({savingPassword: false});
    };

    render() {
        const {classes, profile} = this.props;
        const {
            savingProfile, savingPassword, profileEditable, showNotification, notificationText,
            clearPasswordForm, isCurrentPasswordInvalid, passwordChangeError, profileUpdateError,
        } = this.state;
        return (
            <div>

                <SectionTitleContainer>
                    <SectionTitle>Profile</SectionTitle>
                </SectionTitleContainer>

                <div style={{display: this.state.loading === true ? 'none' : 'block'}} className={classes.tabs}>
                    <Tabs
                        value={this.state.tabIndex}
                        onChange={ignoreFirstArg(this.handleChangeIndex)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth">
                        <Tab value={0} label="Personal Info"/>
                        <Tab value={1} label="Password"/>
                    </Tabs>
                </div>

                <main className={classes.main}>
                    <SwipeableViews index={this.state.tabIndex} onChangeIndex={this.handleChangeIndex}>
                        <ProfileEditor onSubmit={this.profileSubmit}
                                       requestInProgress={savingProfile}
                                       profileInfo={profile}
                                       editable={profileEditable}
                                       onEditionClick={() => this.setState({profileEditable: !profileEditable})}
                                       generalError={profileUpdateError}/>

                        <PassEditor onSubmit={this.passwordSubmit}
                                    requestInProgress={savingPassword}
                                    isClearFormNeeded={clearPasswordForm}
                                    isCurrentPasswordInvalid={isCurrentPasswordInvalid}
                                    generalError={passwordChangeError}/>

                    </SwipeableViews>
                </main>

                <Notification open={showNotification}
                              type={SUCCESS_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({showNotification: false})}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({showNotification: false})}>
                    {notificationText}
                </Notification>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
    }
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveProfile: receive_profile,
    }, dispatch)
});

const UserEditContentStyled = withStyles(styles)(Index);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(UserEditContentStyled));
